<div class="pricing-container">
  <div i18n="@@weHavePlanForEveryone" class="mat-headline-4 text-center mb-34">We have a plan for everyone!</div>
  <div class="cards-container">
    @if (promotionCodeCount < 5 && !isItManufacturer) {
      <mat-card>
        <mat-card-content>
          <div class="box-padding">
            <div i18n="@@lite" class="mat-headline-4 mb-24 d-inline-flex">Lite</div>
            <div class="star-box mb-24">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
            </div>
            <div class="mb-65">
              <div i18n="@@freeOfChanrge" class="d-inline mat-heading">€ FOC</div>
              <div i18n="@@annualFee" class="d-inline mat-caption">/Annual Fee</div>
            </div>
            <div class="mat-caption mb-24">
              <span i18n="@@getExtraSubscription">Get 1 extra subscription for just</span>
              <span class="subscription-color"> € 450</span>
            </div>
          </div>
          <div class="button-margin">
            @if (promotionCodeCount < 5) {
              <button i18n="@@currentPlan" mat-raised-button color="accent" disabled class="w-100 current-plan-button">Current Plan</button>
            }
          </div>
        </mat-card-content>
      </mat-card>
    }
    @if (promotionCodeCount < 10) {
      <mat-card>
        <mat-card-content>
          <div class="box-padding">
            <div i18n="@@bronze" class="mat-headline-4 mb-24">Bronze</div>
            <div class="star-box mb-24">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
            </div>
            <div class="mb-24">
              <div class="d-inline mat-heading">€4,950</div>
              <div i18n="@@annualFee" class="d-inline mat-caption">/Annual Fee</div>
            </div>
            <div class="mat-heading subscription-color mb-24">5 <span i18n="@@subscribtions">Subscriptions</span></div>
            <div class="mat-caption">
              <span i18n="@@getExtraSubscription">Get 1 extra subscription for just</span>
              <span class="subscription-color"> € 400</span>
            </div>
          </div>
          <div class="button-margin">
            @if (promotionCodeCount < 5) {
              <button i18n="@@subscribe" data-testid="openSignup_button" (click)="goToBilling(4950, 'Bronze', 5, 400, '4950', 2)" mat-raised-button color="primary" class="w-100">Subscribe</button>
            }
            @if (promotionCodeCount > 4) {
              <button i18n="@@currentPlan" mat-raised-button color="accent" disabled class="w-100 current-plan-button">Current Plan</button>
            }
          </div>
        </mat-card-content>
      </mat-card>
    }
    @if (promotionCodeCount < 20) {
      <mat-card>
        <mat-card-content>
          <div class="box-padding">
            <div i18n="@@silver" class="mat-headline-4 mb-24">Silver</div>
            <div class="star-box mb-24">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
            </div>
            <div class="mb-24">
              <div class="d-inline mat-heading">€ 6,700</div>
              <div i18n="@@annualFee" class="d-inline mat-caption">/Annual Fee</div>
            </div>
            <div class="mat-heading subscription-color mb-24">10 <span i18n="@@subscribtions">Subscriptions</span></div>
            <div class="mat-caption">
              <span i18n="@@getExtraSubscription">Get 1 extra subscription for just</span>
              <span class="subscription-color"> € 375</span>
            </div>
          </div>
          <div class="button-margin">
            @if (promotionCodeCount < 10) {
              <button i18n="@@subscribe" data-testid="openSignup_button" (click)="goToBilling(6700, 'Silver', 10, 375, '6700', 3)" mat-raised-button color="primary" class="w-100">Subscribe</button>
            }
            @if (promotionCodeCount > 9) {
              <button i18n="@@currentPlan" mat-raised-button color="accent" disabled class="w-100 current-plan-button">Current Plan</button>
            }
          </div>
        </mat-card-content>
      </mat-card>
    }
    @if (promotionCodeCount < 50) {
      <mat-card>
        <mat-card-content>
          <div class="box-padding">
            <div i18n="@@gold" class="mat-headline-4 mb-24">Gold</div>
            <div class="star-box mb-24">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
            </div>
            <div class="mb-24">
              <div class="d-inline mat-heading">€9,950</div>
              <div i18n="@@annualFee" class="d-inline mat-caption">/Annual Fee</div>
            </div>
            <div class="mat-heading subscription-color mb-24">20 <span i18n="@@subscribtions">Subscriptions</span></div>
            <div class="mat-caption">
              <span i18n="@@getExtraSubscription">Get 1 extra subscription for just</span>
              <span class="subscription-color"> € 350</span>
            </div>
          </div>
          <div class="button-margin">
            @if (promotionCodeCount < 20) {
              <button i18n="@@subscribe" data-testid="openSignup_button" (click)="goToBilling(9950, 'Gold', 20, 350, '9950', 4)" mat-raised-button color="primary" class="w-100">Subscribe</button>
            }
            @if (promotionCodeCount > 19) {
              <button i18n="@@currentPlan" mat-raised-button color="accent" disabled class="w-100 current-plan-button">Current Plan</button>
            }
          </div>
        </mat-card-content>
      </mat-card>
    }
    @if (promotionCodeCount < 100) {
      <mat-card>
        <mat-card-content>
          <div class="box-padding">
            <div i18n="@@platinum" class="mat-headline-4 mb-24">Platinum</div>
            <div class="star-box mb-24">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
            </div>
            <div class="mb-24">
              <div class="d-inline mat-heading">€19,200</div>
              <div i18n="@@annualFee" class="d-inline mat-caption">/Annual Fee</div>
            </div>
            <div class="mat-heading subscription-color mb-24">50 <span i18n="@@subscribtions">Subscriptions</span></div>
            <div class="mat-caption">
              <span i18n="@@getExtraSubscription">Get 1 extra subscription for just</span>
              <span class="subscription-color"> € 325</span>
            </div>
          </div>
          <div class="button-margin">
            @if (promotionCodeCount < 50) {
              <button i18n="@@subscribe" data-testid="upgrade_button" (click)="goToBilling(19200, 'Platinum', 50, 325, '19200', 5)" mat-raised-button color="primary" class="w-100">Subscribe</button>
            }
            @if (promotionCodeCount > 49) {
              <button i18n="@@currentPlan" mat-raised-button color="accent" disabled class="w-100 current-plan-button">Current Plan</button>
            }
          </div>
        </mat-card-content>
      </mat-card>
    }
    @if (promotionCodeCount < 200) {
      <mat-card>
        <mat-card-content>
          <div class="box-padding">
            <div i18n="@@diamond" class="mat-headline-4 mb-24">Diamond</div>
            <div class="star-box mb-24">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
            </div>
            <div class="mb-24">
              <div class="d-inline mat-heading">€32,950</div>
              <div i18n="@@annualFee" class="d-inline mat-caption">/Annual Fee</div>
            </div>
            <div class="mat-heading subscription-color mb-24">100 <span i18n="@@subscribtions">Subscriptions</span></div>
            <div class="mat-caption">
              <span i18n="@@getExtraSubscription">Get 1 extra subscription for just</span>
              <span class="subscription-color"> € 300</span>
            </div>
          </div>
          <div class="button-margin">
            @if (promotionCodeCount < 100) {
              <button i18n="@@subscribe" data-testid="upgrade_button" (click)="goToBilling(32950, 'Diamond', 100, 300, '32950', 6)" mat-raised-button color="primary" class="w-100">Subscribe</button>
            }
            @if (promotionCodeCount > 99) {
              <button i18n="@@currentPlan" mat-raised-button color="accent" disabled class="w-100 current-plan-button">Current Plan</button>
            }
          </div>
        </mat-card-content>
      </mat-card>
    }
    <mat-card>
      <mat-card-content>
        <div class="box-padding">
          <div i18n="@@titanium" class="mat-headline-4 mb-24">Titanium</div>
          <div class="star-box mb-24">
            <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
            <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
            <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
            <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
            <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
            <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
            <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
          </div>
          <div class="mb-24">
            <div class="d-inline mat-heading">€52,950</div>
            <div i18n="@@annualFee" class="d-inline mat-caption">/Annual Fee</div>
          </div>
          <div class="mat-heading subscription-color mb-24">200 <span i18n="@@subscribtions">Subscriptions</span></div>
          <div class="mat-caption">
            <span i18n="@@getExtraSubscription">Get 1 extra subscription for just</span>
            <span class="subscription-color"> € 250</span>
          </div>
        </div>
        <div class="button-margin">
          @if (promotionCodeCount < 200) {
            <button i18n="@@subscribe" data-testid="upgrade_button" (click)="goToBilling(52950, 'Titanium', 200, 250, '52950', 7)" mat-raised-button color="primary" class="w-100">Subscribe</button>
          }
          @if (promotionCodeCount > 199) {
            <button i18n="@@currentPlan" mat-raised-button color="accent" disabled class="w-100 current-plan-button">Current Plan</button>
          }
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <mat-card class="info-box">
    <mat-card-content>
      <div class="w-50 m-16 mb-30">
        <mat-icon color="primary">fiber_manual_record</mat-icon>
        <div i18n="@@registerOwnProducts" class="d-inline mat-caption info-text" matTooltip ellipsisTooltip>Register your own products.</div>
      </div>
      <div class="w-50 m-16 mb-30">
        <mat-icon color="primary">fiber_manual_record</mat-icon>
        <div i18n="@@mobileAppViewMessage" class="d-inline mat-caption info-text" matTooltip ellipsisTooltip>Mobile application preview using web-application credentials.</div>
      </div>
      <div class="w-50 m-16">
        <mat-icon color="primary">fiber_manual_record</mat-icon>
        <div i18n="@@addManufacturerProducts" class="d-inline mat-caption info-text" matTooltip ellipsisTooltip>Add manufacturer registered products.</div>
      </div>
      <div class="w-50 m-16">
        <mat-icon color="primary">fiber_manual_record</mat-icon>
        <div i18n="@@addManufacturerInfo" class="d-inline mat-caption info-text" matTooltip ellipsisTooltip>Add on to manufacturer registered information.</div>
      </div>
    </mat-card-content>
  </mat-card>

  <div class="mat-caption mt-100">
    <span i18n="@@downgradePlan" matTooltip ellipsisTooltip>If you would like to downgrade your plan or in case you require more than 20 subscriptions please </span>
    <a i18n="@@conatctUs" routerLink="/contact-us">contact us!</a>
    <span i18n="@@tailoredOffer"> for a tailored offer.</span>
  </div>
</div>
